module.exports = __webpack_public_path__ + "static/media/icon-instagram.0242f825.svg";